<template>

  <div v-if="isCurrentGNB('reporting') && eventInfo.length > 0">

    <div class="summary" :class="{show: !isHidden}"  v-on:click="isHidden = !isHidden">
      <ul>
        <li class="entry"><em><b>{{eventInfo[0].value}}</b> / {{eventInfo[1].value}}</em> Players Left</li>
        <li class="level">Level {{eventInfo[4].value}}. {{eventInfo[5].value}}</li>
      </ul>
    </div>

    <div class="report_info" :class="{show: isHidden}">
      <ul class="title">
        <li>Event Info.</li>
      </ul>
      <ul class="cont">
        <li><p>{{ eventInfo[0].value }}</p>Players Left</li>
        <li><p>{{ eventInfo[1].value }}</p>Entries</li>
      </ul>
      <ul class="cont">
        <li><p>{{ eventInfo[2].value }}</p>Prize Pool</li>
        <li><p>{{ eventInfo[3].value }}</p>1st Prize</li>
      </ul>
      <ul class="cont">
        <li><p>Level {{ eventInfo[4].value }}.</p>{{ eventInfo[5].value }}</li>
      </ul>
      <ul class="cont">
        <li><p>{{ eventInfo[6].value }}</p>Starting Stack</li>
        <li><p>{{ eventInfo[7].value }}</p>Average Stack</li>
      </ul>
    </div>

  </div>

</template>

<script>
  import CommonComputed from 'src/_mixins/CommonComputed'
  import CommonMethods from 'src/_mixins/CommonMethods'
  export default {
    name: 'ReportInfo',
    props: {
      eventInfo: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    data () {
      return {
        isHidden: true
      }
    },
    computed: {
      ...CommonComputed,
      getAccess () {
        return 'pc'
      },
      isMobile () {
        return this.getAccess === 'mobile'
      },
    },
    methods: {
      ...CommonMethods,
       isCurrentGNB (name) {
        return this.$route.path.indexOf(name) > -1
      }
    }
  }
</script>

<style scoped>
  .report_info {
    width: 100%;
    background: #fff;
    margin-bottom: 40px;
    display: none;
    margin-top: 40px;
  }
  .report_info.show {
    display: block;
  }
  .report_info ul {
    display: table;
    width: 100%;
    text-align: center;
    border-bottom: 1px solid rgba(55,147,37,0.35);
  }
  .report_info ul:first-child {
    border-bottom: 0;
  }
  .report_info ul:last-child {
    border-bottom: 0;
  }
  .report_info .cont li:nth-child(2) {
    border-left: 1px solid rgba(255,255,255,0.06);
  }
  .report_info li {
    display: table-cell;
    width: 50%;
    text-align: center;
    line-height: 1.5em;
    padding: 20px 10px;
    color: rgba(255,255,255,0.55);
  }
  .report_info li p {
    font-weight: 700;
    color: rgba(255,255,255,1.0);
  }
  .report_info .cont {
    background: #003501;
  }
  .report_info .cont:nth-child(2) li p {
    font-size: 1.4em;
  }
  .report_info .title li {
    background: #008c03;
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    padding: 10px;
  }
  .summary {
    display: none;
  }
</style>
